module.exports = __webpack_public_path__ + "6b1c96fb4f80603fa0e68d7c5032ca95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-17.png
// module id = 3141
// module chunks = 0